import { useAccountStore } from '@/stores/account';

export const useFeatures = () => {
  const accountStore = useAccountStore();

  const hasFeature = (featureName: string): boolean => accountStore.features.includes(featureName);

  return {
    hasFeature,
  };
};
